<template>
  <div class="changepwd">
    <el-card class="card">
      <div slot="header"
           class="clearfix">
        <span>{{ $t('sys.changePass') }}</span>
      </div>
      <el-form ref="data"
               :model="data"
               status-icon
               label-width="70px"
               class="demo-ruleForm"
               :rules="rules">
        <el-form-item :label="$t('menu.jmm')"
                      prop="oldPass">
          <el-input v-model="data.oldPass" type="password" size="mini"
                    :placeholder="$t('menu.qsrjmm')"></el-input>
        </el-form-item>
        <el-form-item :label="$t('menu.xmm')"
                      prop="pass">
          <el-input type="password" size="mini"
                    v-model="data.pass"
                    :placeholder="$t('menu.qsrxmm')"
                    autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item :label="$t('menu.qrmm')"
                      prop="checkPass">
          <el-input type="password" size="mini"
                    v-model="data.checkPass"
                    :placeholder="$t('menu.qrxmm')"
                    autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div class="btnmg">
          <el-button type="primary" size="mini" @click="submitForm('data')">{{ $t('menu.save') }}</el-button>
          <el-button size="mini" @click="resetForm('data')">{{ $t('menu.cancel') }}</el-button>
      </div>
    </el-card>
  </div>
</template>

<script>
import ApiService from '@/services/API-services'
export default {
  name: 'changePwd',
  props: ['show', 'glid'],
  data() {
    const validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入新密码'))
      } else {
        if (value.length < 1) {
          callback(new Error('新密码不能小于一位'))
        } else {
          if (this.data.checkPass !== '') {
            this.$refs.data.validateField('checkPass')
          }
          callback()
        }
      }
    }
    const validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入新密码'))
      } else if (value !== this.data.pass) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }
    return {
      data: {
        oldPass: '',
        pass: '',
        checkPass: ''
      },
      rules: {
        oldPass: [
          { require: true, message: '请输入旧密码', trigger: 'blur' }
        ],
        pass: [
          { validator: validatePass, trigger: 'blur' }
        ],
        checkPass: [
          { validator: validatePass2, trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    // 保存
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // 上传新数据接口
          ApiService.octopus_user.changePwd({
            newPassword: this.data.checkPass,
            oldPassword: this.data.oldPass,
            id: JSON.parse(localStorage.user).userId
          }).then(res => {
            if (res.code === 0) {
              this.$message({
                type: 'success',
                message: '修改成功,请重新登录'
              })
              setTimeout(() => {
                window.location.href = '/'
              }, 2000)
            } else {
              this.$message({
                type: 'error',
                message: '密码修改失败，请检查旧密码是否正确'
              })
              this.$refs[formName].resetFields()
            }
          })
        } else {
          return false
        }
      })
    },
    // 取消、关闭
    resetForm(formName) {
      if (formName) {
        this.$refs[formName].resetFields()
      }
      this.$store.commit('closeModal', 'changePwd')
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../common/css/color.scss';
.changepwd {
  .card {
    box-shadow: 0px 9px 28px 8px rgba(0, 0, 0, 0.2), 0px 6px 16px 0px rgba(0, 0, 0, 0.32), 0px 3px 6px -4px rgba(0, 0, 0, 0.48) !important;
    width: 342px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/user/changePwd.vue